import BoldText from '@/components/BoldText';
import { apiCaller } from '@/redux/query';
import { isSkipApiSelector } from '@/redux/slice/auth.slice';
import { isLoadingGeneralSettingsSelector } from '@/redux/slice/loading';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { Badge, Button, Card, Icon } from '@shopify/polaris';
import { XCircleIcon, CheckCircleIcon } from '@shopify/polaris-icons';
import { memo } from 'react';
import { useSelector } from 'react-redux';

const ActiveApp = () => {
  const dataSettings = useSelector(dataSettingsSelector);
  const isSkip = useSelector(isSkipApiSelector);
  const [updateGeneralSetting, { isLoading }] = apiCaller.useUpdateGeneralSettingMutation();
  const isNotEnableApp = !dataSettings?.enable_app;
  const isLoadingSetting = useSelector(isLoadingGeneralSettingsSelector);

  const handleActiveApp = () => {
    if (isSkip) return;
    updateGeneralSetting({ ...dataSettings, enable_app: 1 });
  };

  return (
    <Card>
      <div className="d-flex">
        {isNotEnableApp ? <Icon source={XCircleIcon} tone="critical" /> : <Icon source={CheckCircleIcon} tone="success" />}
        <div className="ml-8">
          <BoldText>Activate app</BoldText>
        </div>
        {isNotEnableApp ? (
          <div className="ml-8">
            <Badge tone="critical">Action required</Badge>
          </div>
        ) : null}
      </div>
      {isNotEnableApp ? (
        <div>
          <Button onClick={handleActiveApp} variant="primary" loading={isLoading || isLoadingSetting}>
            Turn on
          </Button>
        </div>
      ) : null}
    </Card>
  );
};

export default memo(ActiveApp);
